import React from 'react';
import ReactDOM from 'react-dom';
import Quiz from './Quiz';
import registerServiceWorker from './registerServiceWorker';
import WebFont from 'webfontloader';
import './styles/index.css';

/**
 * Lazyload fonts with WebFontLoader
 */
WebFont.load({
  google: {
    families: ['Fira Sans:200,300,600:latin-ex'],
  },
});

ReactDOM.render(<Quiz />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js